var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyListGiveaways(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6244 5C18.0786 5.01028 12.6222 5.19895 9.16057 8.66057C5.69895 12.1222 5.51028 17.5786 5.5 28.1244H17.7838C16.9064 27.0284 16.2508 25.7357 15.8933 24.3057C14.5476 18.9232 19.4232 14.0476 24.8057 15.3933C26.2357 15.7508 27.5284 16.4064 28.6244 17.2838V5Z",
    fill: "url(#paint0_linear_2474_20966)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 31.8744C5.51028 42.4202 5.69895 47.8766 9.16057 51.3382C12.6222 54.7999 18.0786 54.9885 28.6244 54.9988V35.3085C26.6753 39.2016 22.6495 41.8744 17.9994 41.8744C16.9639 41.8744 16.1244 41.0349 16.1244 39.9994C16.1244 38.9639 16.9639 38.1244 17.9994 38.1244C21.8414 38.1244 25.0605 35.4578 25.907 31.8744H5.5Z",
    fill: "url(#paint1_linear_2474_20966)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3744 54.9988C42.9202 54.9885 48.3766 54.7999 51.8382 51.3382C55.2999 47.8766 55.4885 42.4202 55.4988 31.8744H35.0918C35.9383 35.4578 39.1574 38.1244 42.9994 38.1244C44.0349 38.1244 44.8744 38.9639 44.8744 39.9994C44.8744 41.0349 44.0349 41.8744 42.9994 41.8744C38.3493 41.8744 34.3235 39.2016 32.3744 35.3085V54.9988Z",
    fill: "url(#paint2_linear_2474_20966)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4988 28.1244C55.4885 17.5786 55.2999 12.1222 51.8382 8.66057C48.3766 5.19895 42.9202 5.01028 32.3744 5V17.2838C33.4704 16.4064 34.7632 15.7508 36.1931 15.3933C41.5757 14.0476 46.4512 18.9232 45.1055 24.3057C44.748 25.7357 44.0924 27.0284 43.215 28.1244H55.4988Z",
    fill: "url(#paint3_linear_2474_20966)",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8962 19.0313C26.675 19.726 28.6244 22.2228 28.6244 25.0871V28.1244H25.5871C22.7228 28.1244 20.226 26.175 19.5313 23.3962C18.8723 20.7601 21.2601 18.3723 23.8962 19.0313Z",
    fill: "url(#paint4_linear_2474_20966)",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3744 25.0871V28.1244H35.4117C38.276 28.1244 40.7728 26.175 41.4675 23.3962C42.1265 20.7601 39.7387 18.3723 37.1026 19.0313C34.3238 19.726 32.3744 22.2228 32.3744 25.0871Z",
    fill: "url(#paint5_linear_2474_20966)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2474_20966",
    x1: 33.742,
    y1: 5,
    x2: 33.742,
    y2: 54.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2474_20966",
    x1: 33.742,
    y1: 5,
    x2: 33.742,
    y2: 54.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2474_20966",
    x1: 33.742,
    y1: 5,
    x2: 33.742,
    y2: 54.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2474_20966",
    x1: 33.742,
    y1: 5,
    x2: 33.742,
    y2: 54.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2474_20966",
    x1: 33.742,
    y1: 5,
    x2: 33.742,
    y2: 54.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2474_20966",
    x1: 33.742,
    y1: 5,
    x2: 33.742,
    y2: 54.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyListGiveaways);
export default __webpack_public_path__ + "static/media/empty-list-giveaways.52ad4ac6ea9be0c58d7543034e972226.svg";
export { ForwardRef as ReactComponent };